(function () {
  function init(root) {
    if (root.dataset.glInit) return;
    root.dataset.glInit = '1';
    var form = root.querySelector('form.gl-form');
    var add = root.querySelector('[data-gl-add]');
    var msg = root.querySelector('[data-gl-msg]');
    var goCheckout = root.dataset.checkout === 'true';

    /* Gallery: swipe, arrows, thumbs (one scrollable row) */
    var slides = root.querySelector('[data-gl-slides]');
    var thumbRow = root.querySelector('.gl-thumbs');
    var thumbs = [].slice.call(root.querySelectorAll('.gl-thumbs button'));
    function count() { return slides ? slides.children.length : 0; }
    function step() { return slides && slides.children[0] ? slides.children[0].offsetWidth : 1; }
    function idx() {
      if (!slides) return 0;
      if (slides.scrollLeft + slides.clientWidth >= slides.scrollWidth - 2) return count() - 1;
      return Math.round(slides.scrollLeft / step());
    }
    function go(i, smooth) {
      if (!slides || !count()) return;
      i = (i + count()) % count();
      slides.scrollTo({ left: slides.children[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function mark() {
      var i = idx();
      thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      var t = thumbs[i];
      if (thumbRow && t && thumbRow.scrollWidth > thumbRow.clientWidth) {
        thumbRow.scrollTo({ left: t.offsetLeft - thumbRow.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      }
    }
    if (slides) {
      var timer;
      slides.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(mark, 60); }, { passive: true });
      var start = slides.querySelector('[data-start]');
      if (start) {
        var si = [].indexOf.call(slides.children, start);
        requestAnimationFrame(function () { go(si, false); mark(); });
      }
      window.addEventListener('resize', function () { go(idx(), false); });
    }
    var prev = root.querySelector('[data-gl-prev]');
    var next = root.querySelector('[data-gl-next]');
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    function goMedia(id) {
      if (!slides || !id) return;
      var el = slides.querySelector('[data-media-id="' + id + '"]');
      if (el) go([].indexOf.call(slides.children, el));
    }

    /* Variant options */
    root.querySelectorAll('input[name="id"][type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        root.querySelectorAll('[data-gl-price]').forEach(function (el) { el.textContent = r.dataset.price; });
        var tt = root.querySelector('[data-gl-sticky-title]');
        if (tt) tt.textContent = r.dataset.title + ' · ';
        goMedia(r.dataset.mediaId);
      });
    });

    /* How-to video: tap to play from the start, with sound */
    root.querySelectorAll('[data-gl-howto]').forEach(function (w) {
      var v = w.querySelector('video');
      var play = w.querySelector('[data-gl-play]');
      if (!v) return;
      var trim = parseFloat(w.dataset.trim || '0') || 0;
      v.removeAttribute('autoplay');
      v.removeAttribute('loop');
      v.autoplay = false;
      v.loop = false;
      v.controls = false;
      try { v.pause(); v.currentTime = 0; } catch (e) {}
      function reset() {
        v.pause();
        try { v.currentTime = 0; } catch (e) {}
        w.classList.remove('is-playing');
      }
      function startPlay() {
        v.muted = false;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        w.classList.add('is-playing');
      }
      if (play) play.addEventListener('click', startPlay);
      v.addEventListener('click', function () {
        if (v.paused) startPlay(); else { v.pause(); w.classList.remove('is-playing'); }
      });
      v.addEventListener('timeupdate', function () {
        if (trim && v.duration && v.currentTime >= v.duration - trim) reset();
      });
      v.addEventListener('ended', reset);
    });

    /* Add to cart */
    if (form && add) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      msg.hidden = true;
      fetch(root.dataset.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw d; return d; }); })
        .then(function () { window.location.href = goCheckout ? '/checkout' : root.dataset.cart; })
        .catch(function (err) {
          msg.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
          msg.classList.add('gl-msg--err');
          msg.hidden = false;
          add.disabled = false;
        });
    });

    /* Sticky buy bar */
    var sticky = root.querySelector('[data-gl-sticky]');
    if (sticky && add && 'IntersectionObserver' in window) {
      var sbtn = root.querySelector('[data-gl-sticky-btn]');
      new IntersectionObserver(function (en) {
        var e = en[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        sbtn.tabIndex = on ? 0 : -1;
      }).observe(add);
      sbtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else add.click(); });
    }
  }
  function all() { document.querySelectorAll('[data-gl-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();